module.exports = __webpack_public_path__ + "static/media/speaker_Tencent_WanChao.841bde3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_Tencent_WanChao.jpg
// module id = 254
// module chunks = 0